import { z } from 'zod';
import { TagSchema } from '@eigtech/resource-tagging-types';
export const documentTypeTagKey = 'DocumentType';
const DocumentTypeTagSchema = z
    .object({
    key: z.literal(documentTypeTagKey),
})
    .merge(TagSchema.omit({ key: true, value: true }));
export const documentTypePhotoReportTagValue = 'PhotoReport';
export const DocumentTypePhotoReportTagSchema = DocumentTypeTagSchema.merge(z.object({
    value: z.literal(documentTypePhotoReportTagValue),
}));
export const makeDocumentTypePhotoReportTag = (resourceCorn, color) => ({
    resourceCorn,
    key: documentTypeTagKey,
    value: documentTypePhotoReportTagValue,
    color,
});
